import { Trans, useTranslation } from "react-i18next";
import { ConfirmationModal } from "@common/ConfirmationModal/ConfirmationModal";
import { useRecommendationBannerRemovalModal } from "@features/RecommendationBannerRemovalModal/useRecommendationBannerRemovalModal";
import { KeyedMutator } from "swr";
import { useState } from "react";
import { ESHOP_URL } from "@constants";
import { Link } from "@mui/material";
import CloseRounded from "@mui/icons-material/CloseRounded";
import { useStyle } from "./style";

interface IParams {
    isRemoveRecommendationBannerModalOpen: boolean;
    mutateRecommendationBanner: KeyedMutator<string>;
    topOffset?: number;
    setIsRemoveRecommendationBannerModalOpen(isRemoveRecommendationBannerModalOpen: boolean): void;
}

export const RecommendationBannerRemovalModal = (props: IParams) => {
    const {
        isRemoveRecommendationBannerModalOpen,
        mutateRecommendationBanner,
        topOffset,
        setIsRemoveRecommendationBannerModalOpen,
    } = props;
    const { classes } = useStyle();
    const { t } = useTranslation(["common", "recommendationBanner"]);
    const {
        handleCloseRecommendationBanner,
        isRecommendationBannerClosing,
        error,
    } = useRecommendationBannerRemovalModal({
        mutate: mutateRecommendationBanner,
    });
    const [isSuccessStep, setIsSuccessStep] = useState(false);

    const handleClose = () => {
        setIsRemoveRecommendationBannerModalOpen(false);
    };

    const handleOnContinue = async () => {
        if (isSuccessStep) {
            handleClose();

            return;
        }
        const isClosed = await handleCloseRecommendationBanner();
        if (isClosed) {
            setIsSuccessStep(true);
        }
    };

    return (
        <ConfirmationModal
            closeIcon={<CloseRounded className={classes.closeIcon} color="secondary" />}
            continueLabel={isSuccessStep ? t("common:close") : t("recommendationBanner:confirmationModalContinue")}
            error={isSuccessStep ? undefined : error}
            hideCancel={isSuccessStep}
            isLoading={isRecommendationBannerClosing}
            isModalOpen={isRemoveRecommendationBannerModalOpen}
            subtitle={
                isSuccessStep ? (
                    <Trans
                        components={{
                            1: (
                                <Link
                                    color="primary"
                                    href={ESHOP_URL}
                                    rel="noopener noreferrer"
                                    target="_blank"
                                    underline="always"
                                />
                            ),
                        }}
                        i18nKey="successModalSubtitle"
                        ns="recommendationBanner"
                    />
                ) : (
                    t("recommendationBanner:confirmationModalSubtitle")
                )
            }
            title={
                isSuccessStep
                    ? t("recommendationBanner:successModalTitle")
                    : t("recommendationBanner:confirmationModalTitle")
            }
            topOffset={topOffset}
            onClose={handleClose}
            onContinue={handleOnContinue}
        />
    );
};
